import { render, staticRenderFns } from "./AdminContrattiProvvisoriView.vue?vue&type=template&id=03053b38&"
import script from "./AdminContrattiProvvisoriView.vue?vue&type=script&lang=ts&"
export * from "./AdminContrattiProvvisoriView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports